import React from 'react';
import imageManifest from './imageManifest';
import './events.css';
import ImageTable from './ImageTable';

const Projects = () => {
  const images = [
    { id: 1, ...imageManifest['sch1.jpg'] },
    { id: 2, ...imageManifest['sch2.jpg'] },
    { id: 3, ...imageManifest['sch3.jpg'] },
    { id: 4, ...imageManifest['sch4.jpg'] },
    { id: 5, ...imageManifest['sch5.jpg'] },
    { id: 6, ...imageManifest['sch6.jpg'] },
    { id: 7, ...imageManifest['sch7.jpg'] },
    { id: 8, ...imageManifest['sch8.jpg'] }
  ]
  return (
    <div>
      <h5>Projects Needing Immediate Attention</h5> 
      <div>
        <ImageTable
          images={images.map(img => ({ src: img.src, alt: `Project ${img.id}` }))}
        />
      </div>
    </div>
  );
};

export default Projects;

//<img className="images" src={schImages}></img>
